module.exports = __webpack_public_path__ + "static/media/robot.5a7fc591.svg";